var map = {
	"./22112043_6587176.jpg": 8931,
	"./Asset-line.svg": 7932,
	"./COPPER_LITE.png": 1293,
	"./GOLD_CONNECT.png": 7398,
	"./SILVER_SMART.png": 934,
	"./background-shape.png": 6127,
	"./banner-media__shape.svg": 5247,
	"./banner/banner-rampagesoft1.webp": 9567,
	"./banner/banner-rampagesoft2.webp": 9870,
	"./banner/ram_mo1.webp": 6244,
	"./banner/ram_mo2.webp": 3585,
	"./banner/ram_tb1.webp": 5098,
	"./banner/ram_tb2.webp": 4619,
	"./bannertest.webp": 5115,
	"./copper.webp": 5004,
	"./gold.webp": 3843,
	"./icon/xlab.svg": 7214,
	"./logo/LOGO_RAMPAGESOFT_2023.png": 4912,
	"./logo/logo512.webp": 5176,
	"./logo/popular-bg.svg": 8280,
	"./logo/pricing-bg.svg": 7507,
	"./popup/3x.webp": 4409,
	"./popup/blog.webp": 5242,
	"./popup/dev.webp": 1521,
	"./popup/dm.webp": 2445,
	"./popup/ecommerce.webp": 2842,
	"./popup/farm.webp": 5574,
	"./popup/high.webp": 9138,
	"./popup/hotel.webp": 9952,
	"./popup/kokko.webp": 7019,
	"./popup/mlm.webp": 802,
	"./popup/real_estate.webp": 7471,
	"./popup/school.webp": 3190,
	"./popup/seo.webp": 6003,
	"./popup/solar.webp": 8175,
	"./popup/spa.webp": 3036,
	"./popup/webdesign.webp": 8450,
	"./rampagesoft-design.webp": 7465,
	"./rampagesoft_webdesign21.webp": 2,
	"./slide/10276612_4421959.svg": 1585,
	"./slide/10780595_19199559.svg": 467,
	"./slide/155629914_6d44cb86-d4d8-478d-ab1d-c3b69b049c1d.svg": 4826,
	"./slide/15917681_5679655.svg": 5417,
	"./slide/21743679_6500556.svg": 7824,
	"./slide/24784485_2020_11_28_spa03.svg": 4840,
	"./slide/26432841_miningindustry_online_1.svg": 3148,
	"./slide/26477198_diplomat_online1.svg": 6597,
	"./slide/26477270_critic_online_1.svg": 9883,
	"./slide/28158353_jobinterview_online_2.svg": 2200,
	"./slide/28772290_7484893.svg": 6400,
	"./slide/3759883_35675.svg": 8595,
	"./slide/4463224_2388717.svg": 2693,
	"./slide/digital1.webp": 5112,
	"./slide/digital2.webp": 3717,
	"./slide/digital3.webp": 6714,
	"./slide/digital4.webp": 9895,
	"./slide/digital5.webp": 5860,
	"./slide/digital6.webp": 385,
	"./slide/digital7.webp": 4278,
	"./slide/digital8.webp": 2435,
	"./slide/digital9.webp": 4944,
	"./slide/famer.svg": 8230,
	"./slide/ram_slide1.webp": 8430,
	"./slide/ram_slide2.webp": 8127,
	"./slide/ram_slide3.webp": 6540,
	"./sliver.webp": 418,
	"./success/3x.webp": 9274,
	"./success/blog.webp": 2365,
	"./success/high.webp": 6817,
	"./success/kokko.webp": 1106,
	"./success/mlm.webp": 9888,
	"./success/real_estate.webp": 1374,
	"./success/school.webp": 277,
	"./success/seo.webp": 786,
	"./success/solar.webp": 4458,
	"./success/spa.webp": 7081,
	"./theme/t0.webp": 2011,
	"./theme/t1.webp": 4632,
	"./theme/t2.webp": 4389,
	"./theme/t3.webp": 122,
	"./theme/t4.webp": 1655,
	"./theme/t5.webp": 9060,
	"./webdesign19-index1.webp": 1479,
	"./website1.webp": 9717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;